import { render, staticRenderFns } from "./YesNoNaButton.vue?vue&type=template&id=48eae6e8&"
import script from "./YesNoNaButton.vue?vue&type=script&lang=js&"
export * from "./YesNoNaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports